<div *ngIf="!!inBreadcrumbLevels || !!lastLoggedOut">
   <carm-breadcrumb-view [levels]="inBreadcrumbLevels" [lastLoggedOut]="lastLoggedOut"></carm-breadcrumb-view>
</div>

<div *ngIf="!!inLocalizedPageTitle && !inHideTopTitleInfo" class="pageTitle">
  <h1 id="wb-cont">{{inLocalizedPageTitle}}</h1>
</div>

<carm-alerts [displayAlertsForPage]="resolvedDisplayAlertsForPage" [isPublic]='false'></carm-alerts>

<div *ngIf="!!inLocalizedPageShortDescription && !inHideTopTitleInfo">
    <p [innerHtml]="inLocalizedPageShortDescription"></p>
</div>

<ng-content></ng-content>
